var e = {};
export {
  e as __exports
};
//# sourceMappingURL=index.es342.js.map
